import { parseDate } from '@internationalized/date';
import { useMemo } from 'react';

import BookingParameters from '../../../types/BookingParameters';
import RequestedDates from '../types/RequestedDates';

const useRequestedDates = (
    parameters: BookingParameters
): RequestedDates | undefined => {
    return useMemo(() => {
        if (
            !parameters.requestedPickupDate ||
            !parameters.requestedReturnDate
        ) {
            return undefined;
        }

        return {
            pickupDate: parseDate(parameters.requestedPickupDate),
            returnDate: parseDate(parameters.requestedReturnDate),
        };
    }, [parameters.requestedPickupDate, parameters.requestedReturnDate]);
};

export default useRequestedDates;
